module.exports = "https://static.energy5.com/_next/static/images/mobileApp-72e33e5a360cf9fa0e3f574690bf2cfe.png";